(function ($) {
    $(document).on('ready', function () {
        if ($(window).scrollTop() >= 75) {
            $("#primary-menu").addClass("flapDown");
        }
    });
    $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 75) {
            $("#primary-menu").addClass("flapDown");
        }
        else {
            $("#primary-menu").removeClass("flapDown");
        }
    });
})(jQuery);
